import { CustomTypography } from '../Typography';

import { TTextCopy } from './types';

export const TextCopy = ({ label, onClick, ...typographyProps }: TTextCopy) => {
  return (
    <CustomTypography onClick={onClick} {...typographyProps}>
      {label}
    </CustomTypography>
  );
};
